import { render, staticRenderFns } from "./TestAlert.vue?vue&type=template&id=3d3a9770&"
import script from "./TestAlert.vue?vue&type=script&lang=ts&"
export * from "./TestAlert.vue?vue&type=script&lang=ts&"
import style0 from "./TestAlert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports